import { I9nSchemaBySystem } from '@biteinc/common';
import { nutritionInfoSchema } from '@biteinc/schemas';

app.NutritionInfoView = app.NestedObjectFieldView.extend({
  getNestedObjectSchema() {
    const syncCaloriesEnabled = app.integrationList.models.some((i9n) => {
      const schema = I9nSchemaBySystem[i9n.get('system')];
      return schema.type === 'pos' && !!schema.syncsCalories;
    });

    const syncMacronutrientsEnabled = app.integrationList.models.some((i9n) => {
      const schema = I9nSchemaBySystem[i9n.get('system')];
      return schema.type === 'pos' && !!schema.syncsMacronutrients;
    });

    const schema = app.JsonHelper.deepClone(nutritionInfoSchema);
    if (!syncCaloriesEnabled) {
      delete schema.fields.posBaseCalories;
      delete schema.fields.posMaxCalories;
    }
    if (!syncMacronutrientsEnabled) {
      delete schema.fields.posProteinContent;
      delete schema.fields.posFatContent;
      delete schema.fields.posCarbohydrateContent;
      delete schema.fields.posSugarContent;
    }
    return schema;
  },
});
